<template>
	<page-layout class="calendar-page" :title="task && _taskTypes.hasOwnProperty(task.type) ? _taskTypes[task.type].label + ' #' + $filters.number(task.num, 0) : ''" :root="false">
		<div v-if="task" class="content">
			<div class="header">
				<div :class="{ tab: true, active: tab == 'info' }" @click="tab = 'info'">Info</div>
				<div :class="{ tab: true, active: tab == 'team' }" @click="tab = 'team'">Hold</div>
				<div v-if="getSuperType(task.type) != 'move'" :class="{ tab: true, active: tab == 'address' }" @click="tab = 'address'">Adresse</div>
				<div v-if="getSuperType(task.type) == 'move'" :class="{ tab: true, active: tab == 'route' }" @click="tab = 'route'">Rute</div>
				<div v-if="false" :class="{ tab: true, active: tab == 'pack' }" @click="tab = 'pack'">Emballage</div>
				<div :class="{ tab: true, active: tab == 'files' }" @click="tab = 'files'">Filer</div>
				<div :class="{ tab: true, active: tab == 'photos' }" @click="tab = 'photos'">Fotos</div>
				<div :class="{ tab: true, active: tab == 'comments' }" @click="tab = 'comments'">Bemærk</div>
			</div>
			<div v-show="tab == 'info'" class="body">
				<div class="table">
					<div class="title">Kunde</div>
					<div class="item customer">
						<div class="name">{{ task ? task.name : '' }}</div>
						<div v-if="false && task && (task.details.address)" class="address">{{ task.details.address.address }}<br>{{ task.details.address.zip }} {{ task.details.address.city }}<br>{{ task.details.address.country }}</div>
					</div>
					<div v-if="task" class="title">Ansvarlig</div>
					<div v-if="task" class="item remarks">
						{{ task._embedded.employee.name }}
					</div>
					<div v-if="task" class="title">Oprettet af</div>
					<div v-if="task" class="item remarks">
						{{ task._embedded.creator.name }}
					</div>
					<div v-if="task && task._embedded.contact && task._embedded.contact.info != '' && task._embedded.contact.info !== null" class="title">Informationer</div>
					<div v-if="task && task._embedded.contact && task._embedded.contact.info != '' && task._embedded.contact.info !== null" class="item remarks">
						{{ task._embedded.contact.info }}
					</div>
					<div class="title">Bemærkninger</div>
					<div class="item remarks">
						{{ order.remarks_all || '-' }}
					</div>
					<div class="title">Ankomst</div>
					<div class="item arrival">
						<div class="date">{{ task ? $filters.date(task.due_start_from) : '' }}</div>
						<div class="time">{{ task ? arrival(task) : '' }}</div>
					</div>
					<div class="title">Detaljer</div>
					<div class="item arrival">
						<div class="date">Kubik</div>
						<div class="time">{{ task && task.details.cubic ? task.details.cubic : '-' }}</div>
					</div>
					<div class="item arrival">
						<div class="date">Areal</div>
						<div class="time">{{ task && task.details.area ? task.details.area : '-' }}</div>
					</div>
					<div class="item arrival">
						<div class="date">Kundereference</div>
						<div class="time">{{ task && task.reference || '-' }}</div>
					</div>

					<div v-if="getSuperType(task.type) == 'survey'" class="title">Fra</div>
					<div v-if="getSuperType(task.type) == 'survey'" class="item remarks">
						{{ task.details.address.address }}<br>
						{{ task.details.address.zip }} {{ task.details.address.city }}<br>
						{{ task.details.address.country }}
					</div>

					<div class="button" @click="navigationClick(task.details.address)">Find vej</div>

					<div v-if="getSuperType(task.type) == 'survey'" class="title">Til</div>
					<div v-if="getSuperType(task.type) == 'survey'" class="item remarks">
						{{ task.details.dest.address }}<br>
						{{ task.details.dest.zip }} {{ task.details.dest.city }}<br>
						{{ task.details.dest.country }}
					</div>

					<div class="button" @click="navigationClick(task.details.dest)">Find vej</div>

					<div v-if="task && task.remarks" class="title">Bemærkninger</div>
					<div v-if="task && task.remarks" class="item remarks">
						{{ task.remarks }}
					</div>
					<div v-if="_packaging.length > 0" class="title">{{ getSuperType(task.type) == 'pickup' ? 'Afhentes' : 'Leveres' }}</div>
					<div class="item packaging">
						<div v-for="(item, i) in _packaging" :key="i" class="item">
							<div>{{ item.label }}</div>
							<div class="value">{{ item.value }}</div>
						</div>
					</div>
					<div v-if="_inst.length > 0" class="title">Instruktioner</div>
					<div v-for="(instr, i) in _inst" :key="i" class="item instruction">
						<div class="title">{{ _instructions.hasOwnProperty(instr.name) ? _instructions[instr.name].label : '' }}<br><div v-if="getInstructionsMessage(instr.name) != ''" style="color: #f7223f; font-weight: normal; padding-top: 5px;">{{ getInstructionsMessage(instr.name) }}</div></div>
						<div class="body">{{ instr.body }}</div>
					</div>
					<div class="title">Lager</div>
					<div class="button" @click="storage('pickup')">Afhent container</div>
					<div class="button" @click="storage('dropoff')">Aflever container</div>
					<div class="title">Handlinger</div>
					<div class="button" @click="contactClick">Kontakt</div>
					<div v-show="commentTypes.length > 0" class="button" @click="commentClick">Bemærkning</div>
					<div v-show="checkInBtn && !_checkedIn" class="button" @click="checkInClick">Check ind</div>
					<div class="button" @click="refClick">Tilføj kundereference</div>
					<div class="title">Checkliste</div>
					<div :class="{ button: true, disabled: false, done: v.images.length >= task._embedded.checklist.required_vehicle_photos }" @click="vehicleCam(v.id)" v-for="(v, i) in _myVehicles" :key="i">{{ v.images.length }} af {{ task._embedded.checklist.required_vehicle_photos }} billeder af {{ v.name }}</div>
					<div :class="{ button: true, disabled: false, done: _goodsPhotos >= task._embedded.checklist.required_goods_photos }" @click="camera('')">{{ _goodsPhotos }} af {{ task._embedded.checklist.required_goods_photos }} billeder af indbo</div>
					<div v-show="_hasToStorage" :class="{ button: true, disabled: false, done: _storagePhotos > 0 }" @click="camera('lager')">{{ _storagePhotos }} af 1 billede af lager placering</div>
					<div :class="{ button: true, disabled: false, done: task.closed }" @click="finishClick">Afslut</div>
				</div>
			</div>
			<div v-show="tab == 'address'" class="body">
				<div class="table">
					<div class="item arrival">
						<div class="date">
							{{ task.details.address.address }}<br>
							{{ task.details.address.zip }} {{ task.details.address.city }}<br>
							{{ task.details.address.country }}
						</div>
					</div>
					<div class="button" @click="navigationClick(task.details.address)">Find vej</div>
				</div>
			</div>
			<div v-show="tab == 'team'" class="body">
				<div v-for="(t, j) in task._embedded.teams" :key="j" class="table">
					<div class="title">Hold {{ j }}</div>
					<div class="item packaging">
						<div class="title">Medarbejdere</div>
						<div v-for="(p, i) in t.employees" :key="i" class="item">
							<div class="label">{{ p.name }}</div>
							<div class="value"></div>
						</div>
						<div class="title">Køretøjer</div>
						<div v-for="(p, i) in t.vehicles" :key="i" class="item">
							<div class="label">{{ p.name }}</div>
							<div class="value"></div>
						</div>
					</div>
				</div>
			</div>
			<div v-show="tab == 'comments'" class="body">
				<div class="table" v-for="(c, i) in task._embedded.comments" :key="i" @click="editComment(c)">
					<div class="title">{{ c.name }}</div>
					<div class="item remarks" v-html="c.message.replaceAll('\n', '<br>')" />
				</div>
			</div>
			<div v-if="getSuperType(task.type) == 'move'" v-show="tab == 'route'" class="body route">
				<div v-for="(st, i) in task.details.route" :key="i" v-show="stop == i" class="body">
					<div class="table">
						<div class="title">Adresse</div>
						<div class="item remarks">
							{{ st.address }}<br>
							{{ st.zip }} {{ st.city }}<br>
							{{ st.country }}
						</div>
						<div class="button" @click="navigationClick(st)">Find vej</div>
						<div v-show="st.instructions && st.instructions.length > 0" class="title">Instruktioner</div>
						<div v-for="(instr, i) in st.instructions" :key="i" class="item instruction">
							<div class="title">{{ _instructions.hasOwnProperty(i) ? _instructions[i].label : '' }}</div>
							<div class="body">{{ instr }}</div>
						</div>
						<div v-show="typeof st.distance != 'undefined' || typeof st.elevator != 'undefined'" class="title">Detaljer</div>
						<div class="item instruction">
							<div class="title">Elevator</div>
							<div class="body">{{ typeof st.elevator == 'undefined' ? '-' : (st.elevator ? 'Ja' : 'Nej') }}</div>
						</div>
						<div class="item instruction">
							<div class="title">Møbellift</div>
							<div class="body">{{ typeof st.lift == 'undefined' ? '-' : (st.lift ? 'Ja' : 'Nej') }}</div>
						</div>
						<div class="item instruction">
							<div class="title">Afstand til bil</div>
							<div class="body">{{ st.distance || '-' }}</div>
						</div>
						<div class="item instruction">
							<div class="title">Etager</div>
							<div class="body">{{ st.floors || '-' }}</div>
						</div>
					</div>
				</div>
				<div class="stops">
					<div class="stops-center" :style="{
						gridTemplateColumns: '1fr' + ' 20px 1fr'.repeat(task.details.route.length)
					}">
						<div class="left"></div>

						<div v-for="(st, i) in _stops" :key="i" :class="{
							stop: st.type == 'stop',
							center: st.type == 'center',
							active: stop == st.idx
						}" @click="stop = st.idx"><div v-show="st.type == 'stop'" class="halo"></div><div v-show="st.type == 'center'" class="line"></div></div>

					
						<div class="right"></div>
					</div>
				</div>
			</div>
			<div v-show="tab == 'pack'" class="body">
				<div class="table">
					<div class="title">Leveres</div>
					<div class="item packaging">
						<div v-if="false" class="title">Leveres</div>
						<div v-for="(p, i) in task.details.delivery" :key="i" class="item">
							<div class="label">{{ _pack.hasOwnProperty(i) ? _pack[i].label : '' }}</div>
							<div class="value">{{ p }}</div>
						</div>
					</div>
					<div class="button" @click="balanceClick('deliver')">Registrer</div>
					<div class="title">Afhentes</div>
					<div class="item packaging">
						<div v-if="false" class="title">Leveres</div>
						<div v-for="(p, i) in task.details.pickup" :key="i" class="item">
							<div class="label">{{ _pack.hasOwnProperty(i) ? _pack[i].label : '' }}</div>
							<div class="value">{{ p }}</div>
						</div>
					</div>
					<div class="button" @click="balanceClick('pickup')">Registrer</div>
					<div class="title">Til lager</div>
					<div class="button" @click="balanceClick('store')">Registrer</div>
					<div class="title">Fra lager</div>
					<div class="button" @click="balanceClick('extract')">Registrer</div>
				</div>
			</div>
			<div v-show="tab == 'files'" class="body">
				<div class="table">
					<div v-for="(file, i) in task.details.files" :key="i" class="item file">
						<div class="name" @click="open(file.id)">{{ file.label }}</div>
						<div v-if="false" class="type">PDF</div>
					</div>
				</div>
			</div>
			<div v-show="tab == 'photos'" class="body">
				<div class="photos">
					<div class="thumb button" @click="camera" style="background-image: url('/images/icons/camera.svg')"><div class="square" /></div>
					<div @click="openImage(p.id)" v-for="(p, i) in _items" :key="i" class="thumb" :style="{
						backgroundImage: 'url(' + p.url + ')'
					}"><div class="square" /></div>
				</div>
			</div>
		</div>
		<div class="camera" v-show="cam">
			Camera
		</div>
	</page-layout>
</template>

<script>
	import PageLayout from '@/app/layouts/PageLayout'
	import UserFragment from '@/app/fragments/UserFragment'
	import DatePopupView from '@/components/DatePopupView'
	import SelectPopupView from '@/components/SelectPopupView'
	import FormPopupView from '@/components/FormPopupView'
	import SignaturePopupView from '@/components/SignaturePopupView'

	export default {
		components: {
			pageLayout: PageLayout,
		},
		watch: {
			cameraActive(newVal) {
				if (!newVal) {
					this.update()
				}
			}
		},
		data() {
			return {
				order: {},
				checkInBtn: true,
				//packaging: [],
				cam: false,
				settings: [],  
				task: null,
				date: new Date(),
				tab: 'info',
				stop: 0,
				taskTypes: [],
				instructions: [],
				pack: [],
				deliveries: [],
				commentTypes: [],
				sendingBalance: false,
				signingDelivery: false,
				deliveryLiability: 'Kunden underskriver hermed modtagelse af pakkemateriale og hæfter for alt pakkemateriale, der ikke tilbageleveres – pakkepapir indgår ikke i tilbageleveringen.',
				locations: null,
				units: null,
				storeText: '',
				columns: [
					{
						data: ['username'],
						label: 'Username'
					},
					{
						type: 'button',
						data: {
							event: 'delete',
							label: 'Delete'
						},
						label: '',
						weight: '200px',
						align: 'right'
					}
				],
				items: [
					{
						username: 'nicolaj'
					}
				],
				months: [
					'januar',
					'februar',
					'marts',
					'april',
					'maj',
					'juni',
					'juli',
					'august',
					'september',
					'oktober',
					'november',
					'december'
				]
			};
		},
		asyncComputed: {
			_items: {
				lazy: true,
				async get() {
					/*var calls =  [];

					for (var i = 0; i < this.task.details.photos.length; ++i) {
						calls.push(this.axios.get('/storage/urls/' + this.task.details.photos[i].id + '/'));
					}

					var urls = await Promise.all(calls);
					*/
					var i;
					const urls = (await this.axios.post('/storage/urls/', this.task.details.photos.map(item => item.id))).data;

					var r = [];

					console.log(urls);

					for (i = 0; i < this.task.details.photos.length; ++i) {
						r.push({
							id: this.task.details.photos[i].id,
							tags: this.task.details.photos[i].tags,
							url: urls[i]
						});
					}

					console.log(r);

					return r;
				}
			}
		},
		computed: {
			cameraActive() {
				return this.$store.state.cameraActive
			},
			_myVehicles() {
				var r = [];

				if (this.task) {
					for (var i = 0; i < this.task._embedded.vehicles.length; ++i) {
						var v = this.task._embedded.vehicles[i];

						if (v.driver_id == this.$store.getters.user.id) {
							r.push(v);
						}
					}
				}

				return r;
			},
			_goodsPhotos() {
				return this.task ? this.task.details.photos.reduce(function (a, b) { return a + (!b.tags.includes('lager') ? 1 : 0); }, 0) : 0;
			},
			_storagePhotos() {
				return this.task ? this.task.details.photos.reduce(function (a, b) { return a + (b.tags.includes('lager') ? 1 : 0); }, 0) : 0;
			},
			_packaging() {
				if (!this.task) return [];
				var r = [];

				for (var i in this.task.details.packaging || {}) {
					var pack = this.task.details.packaging[i];
					var p = this.deliveries ? this.deliveries.find(function (item) {
						return item.id == i;
					}) : null;

					if (p) {
						r.push({
							label: p.label,
							value: pack
						});
					}
				}

				return r;
			},
			_hasToStorage() {
				return this._inst.reduce(function (a, b) { return a + (b.name == 'store' ? 1 : 0); }, 0) > 0;
			},
			_inst() {
				if (!this.task) return [];
				if (this.getSuperType(this.task.type) != 'move') return [];

				var r = [];

				for (var i = 0; i < this.task.details.route.length; ++i) {
					var stop = this.task.details.route[i];

					console.log('stop', stop);

					// Sometimes empty array
					if (!Array.isArray(stop.instructions)) {
						for (var j in stop.instructions) {
							var instr = stop.instructions[j];

							r.push({
								name: j,
								body: instr
							});
						}
					}
				}

				console.log('instr', r);

				return r;
			},
			_stops() {
				if (!this.task || this.getSuperType(this.task.type) != 'move') return [];

				var r = [];
				var idx = 0;

				if (this.task.details.route.length > 0) {
					r.push({
						type: 'stop',
						idx: idx++
					});
				}

				for (var i = 1; i < this.task.details.route.length; ++i) {
					r.push({
						type: 'center'
					});

					r.push({
						type: 'stop',
						idx: idx++
					});
				}

				return r;
			},
			_taskTypes() {
				var r = {};

				for (var i = 0; i < this.taskTypes.length; ++i) {
					r[this.taskTypes[i].name] = this.taskTypes[i];
				}

				return r;
			},
			_instructions() {
				var r = {};

				for (var i = 0; i < this.instructions.length; ++i) {
					r[this.instructions[i].name] = this.instructions[i];
				}

				console.log(r);

				return r;
			},
			_pack() {
				var r = {};

				for (var i = 0; i < this.pack.length; ++i) {
					r[this.pack[i].id] = this.pack[i];
				}

				console.log(r);

				return r;
			},
			_checkedIn() {
				var self = this;
				return this.task ? this.$store.getters.stamps.find(function (stamp) { return stamp.type == 'in' && stamp.task_id == self.task.id; }) : false;
			}
		},
		methods: {
			getSuperType(type) {
				return type in this._taskTypes ? this._taskTypes[type].super : type;
			},
			async storageContainer(spot, type) {
				const self = this;
				const r = await this.units;
				var unit;
				var store;
				var options = [];

				for (var i = 0; i < r.data._items.length; ++i) {
					unit =  r.data._items[i];

					if (unit.spot_id === null) {
						for (var j = 0; j < unit._embedded.storage.length; ++j) {
							store = unit._embedded.storage[j];

							if (store.contact_id == this.task.contact_id) {
								options.push({
									label: `${unit.name}`,
									callback: (() => {
										const s = spot;
										const u = unit;

										return async () => {
											await self.axios.post("/warehouse/dropoff/", {
												contact_id: self.task.contact_id,
												task_id: self.task.id,
												type: type,
												spot: s,
												unit: u,
												text: self.storeText
											});

											self.$store.commit('clearPopup');
										};
									})()
								});

								break;
							}
						}
					}
				}

				self.$store.commit('pushPopup', {
					component: SelectPopupView,
					props: {
						title: options.length == 0 ? 'Ingen fundet' : 'Container',
						options: options,
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('clearPopup');
								}
							}
						]
					}
				});
			},

			async storageLocation(action, type) {
				const self = this;
				const r = await this.locations;
				var options = [];
				var loc;
				var spot;
				var unit;
				var store;
				var i;
				var j;
				var k;
				var l;

				console.log(action, type);

				// Store text
								// Store text
				if (action == 'dropoff' && type == 'filled' && this._instructions.store) {
					this.storeText = this._instructions.store;
				} else {
					this.storeText = '';
				}

				// Filter
				if (action == 'pickup' && type == 'empty') {
					// Show all empty containers in pickup zones
					console.log('pickup empty');

					for (i = 0; i < r.data._items.length; ++i) {
						console.log('there is locations');
						loc = r.data._items[i];

						for (j = 0; j < loc._embedded.spots.length; ++j) {
							console.log('there is spots');
							spot = loc._embedded.spots[j];

							for (k = 0; k < spot._embedded.units.length; ++k) {
								console.log('there is units');
								unit = spot._embedded.units[k];

								if (unit._embedded.storage.length == 0 && spot.pickup && spot.empty) {
									console.log('fit!!');

									options.push({
										label: `${loc.name}, ${spot.label}, ${unit.name}`,
										callback: (() => {
											const u = unit;

											return async () => {
												await self.axios.post("/warehouse/pickup/", {
													type: 'empty',
													contact_id: self.task.contact_id,
													task_id: self.task.id,
													unit: u
												});

												self.$store.commit('clearPopup');
											}
										})()
									});
								}
							}
						}
					}
				}

				if (action == 'pickup' && type == 'filled') {
					// Show all filled containers in pickup zones, matching contact
					console.log('pickup filled');

					for (i = 0; i < r.data._items.length; ++i) {
						console.log('there is locations');
						loc = r.data._items[i];

						for (j = 0; j < loc._embedded.spots.length; ++j) {
							console.log('there is spots');
							spot = loc._embedded.spots[j];

							for (k = 0; k < spot._embedded.units.length; ++k) {
								console.log('there is units');
								unit = spot._embedded.units[k];

								for (l = 0; l < unit._embedded.storage.length; ++l) {
									store = unit._embedded.storage[l];

									if (store.contact_id == this.task.contact_id && spot.pickup && spot.filled) {
										console.log('fit!!');

										options.push({
											label: `${loc.name}, ${spot.label}, ${unit.name}`,
											callback: (() => {
												const u = unit;

												return async () => {
													await self.axios.post("/warehouse/pickup/", {
														contact_id: self.task.contact_id,
														task_id: self.task.id,
														type: 'filled',
														unit: u
													});

													self.$store.commit('clearPopup');
												}
											})()
										});
									}
								}
							}
						}
					}
				}

				if (action == 'dropoff') {
					// Show all places to put en empty container
					console.log('dropoff empty');

					for (i = 0; i < r.data._items.length; ++i) {
						console.log('there is locations');
						loc = r.data._items[i];

						for (j = 0; j < loc._embedded.spots.length; ++j) {
							console.log('there is spots');
							spot = loc._embedded.spots[j];

							if (spot.dropoff && ((type == 'empty' && spot.empty) || (type == 'filled' && spot.filled))) {
								console.log('fit!!');

								options.push({
									label: `${loc.name}, ${spot.label}`,
									callback: (() => { 
										const s = spot;

										return () => {
											// Container select popup
											self.storageContainer(s, type);
										};
									})()
								});
							}
						}
					}
				}

				if (action == 'dropoff' && type == 'filled') {
					//
				}

				self.$store.commit('pushPopup', {
					component: SelectPopupView,
					props: {
						title: action == 'pickup' ? (options.length == 0 ? 'Ingen fundet' : 'Container') : 'Lokation',
						options: options,
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('clearPopup');
								}
							}
						]
					}
				});
			},

			async storage(action) {
				const self = this;

				console.log(action);

				// Load locations
				this.locations = this.axios.get('/warehouse/locations/');
				this.units = this.axios.get('/warehouse/units/');

				self.$store.commit('pushPopup', {
					component: SelectPopupView,
					props: {
						title: 'Type',
						options: [
							{
								label: 'Tom',
								callback() {
									self.storageLocation(action, 'empty');
								}
							},
							{
								label: 'Fyldt',
								callback() {
									self.storageLocation(action, 'filled');
								}
							}
						],
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('clearPopup');
								}
							}
						]
					}
				});
			},
			getInstructionsMessage(name) {
				return this.settings.instructions ? (this.settings.instructions[name] ? (this.settings.instructions[name] != '' ? this.settings.instructions[name] : '') : '') : '';
			},
			camera(event, tags) {
				/*if (navigator.getUserMedia) {
					console.log('Usse WebRTC');
					this.cam = true;
				} else {
					console.log('native');
					window.location = 'camera:' + this.$store.getters.auth + '@' + (process.env.VUE_APP_API_BASE || 'https://api.moovr.dk/v1') + '/tasks/' + this.$route.params.id + '/photos/';
				}*/


				this.$store.commit('cameraUrl', (process.env.VUE_APP_API_BASE || 'https://api.moovr.dk/v1') + '/tasks/' + this.$route.params.id + '/photos/' + (tags === undefined ? '' : '?tags=' + tags));
				this.$store.commit('cameraActive', true);

				//window.location = 'camera:' + this.$store.getters.auth + '@' + (process.env.VUE_APP_API_BASE || 'https://api.moovr.dk/v1') + '/tasks/' + this.$route.params.id + '/photos/' + (tags === undefined ? '' : '?tags=' + tags);
			},
			vehicleCam(id) {
				/*if (navigator.getUserMedia) {
					console.log('Usse WebRTC');
					this.cam = true;
				} else {
					console.log('native');
					window.location = 'camera:' + this.$store.getters.auth + '@' + (process.env.VUE_APP_API_BASE || 'https://api.moovr.dk/v1') + '/tasks/' + this.$route.params.id + '/photos/';
				}*/

				window.location = 'camera:' + this.$store.getters.auth + '@' + (process.env.VUE_APP_API_BASE || 'https://api.moovr.dk/v1') + '/fleet/vehicles/' + id + '/photos/';
			},
			arrival(book) {
				var from 	= this.$filters.moment(book.due_start_from, 'HH:mm');
				var to 		= this.$filters.moment(book.due_start_to, 'HH:mm');

				return from == to ? from : from + ' - ' + to;
			},
			finish(invite) {
				var self = this;

				this.axios.put('/planning/tasks/' + this.task.id + '/close/', {
					invite: invite === undefined ? false : invite
				}).then(function (r) {
					self.update();
				});
			},
			async testClosed() {
				var task = (await this.axios.get(`/planning/tasks/${this.task.id}/`)).data;
				
				if (task.closed) {
					this.$store.commit('popPopup');
					this.update();

					window.location = 'alert:Opgaven er allerede lukket.';
					alert('Opgaven er allerede lukket');
				}
			},
			async finishClick() {
				console.log('finish');

				if (!this.task) return;

				if (this.task.closed) return;
				
				var self = this;

				
				

				// Did you deliver anything?
				/*self.$store.commit('pushPopup', {
					component: SelectPopupView,
					props: {
						title: 'Emballage',
						options: [
							{
								label: 'Leveret',
								callback() {
									self.balanceClick('deliver', function () {
										self.finish();
										self.$store.commit('popPopup');
									});
								}
							},
							{
								label: 'Afhentet',
								callback() {
									self.balanceClick('pickup', function () {
										self.finish();
										self.$store.commit('popPopup');
									});
								}
							},
							{
								label: 'Ingen emballage',
								callback() {
									self.finish();
									self.$store.commit('popPopup');
								}
							}
						],
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});*/

				var form = [
					{
						label: 'Timer',
						value: 0,
						name: 'hours',
						type: 'number',
						link: 'amount',
						rate: (self.task && self.task.hour_rate) ? Number(self.task.hour_rate) : 0
					},
					{
						label: 'Betalt',
						value: 0,
						name: 'amount',
						type: 'currency'
					},
					{
						label: 'Metode',
						name: 'payment',
						type: 'select',
						value: 'cash',
						options: [
							{
								label: 'Kontant',
								value: 'cash'
							},
							{
								label: 'Kort',
								value: 'card'
							},
							{
								label: 'Faktura',
								value: 'invoice'
							},
							{
								label: 'MobilePay',
								value: 'mobilepay'
							}
						]
					},
					{
						label: 'Emballage leveret',
						value: true,
						name: 'deliver',
						type: 'switch'
					},
					{
						label: 'Emballage afhentet',
						value: true,
						name: 'pickup',
						type: 'switch'
					},
					{
						label: 'Trustpilot invitation',
						value: false,
						name: 'trustpilot',
						type: 'switch'
					},
					{
						label: 'Skade på indbo',
						value: false,
						name: 'claim',
						type: 'switch'
					}
				];

				var F = function (n) { return form.find(function (x) { return x.name === n; }); };

				async function endClosure() {
					console.log('end close', form);

					// Register payment - a payment hiccup must never block the task close.
					var didPay = F('amount').value > 0;
					if (didPay) {
						try {
							await self.axios.post('/tasks/' + self.task.id + '/payments/', {
								amount: F('amount').value,
								method: F('method').value,
								hours: F('hours').value
							});
						} catch (e) {
							console.log('payment failed', e);
						}
					}

					// Close the task FIRST, then notify - nothing (alert/payment) may block the close.
					self.finish(F('trustpilot').value);
					self.$store.commit('clearPopup');

					if (didPay) {
						var paid = ['cash', 'card', 'mobilepay'].indexOf(F('method').value) !== -1;
						window.location = 'alert:Faktura sendt (' + (paid ? 'betalt' : 'ubetalt') + ')';
						alert('Faktura sendt (' + (paid ? 'betalt' : 'ubetalt') + ')');
					}
				}

				async function registerBalance() {
					// Register delivery
					if (F('deliver').value && !F('pickup').value) {
						self.balanceClick('deliver', function () {
							endClosure();
							self.$store.commit('popPopup');
						});
					}

					// Register pickup
					if (!F('deliver').value && F('pickup').value) {
						self.balanceClick('pickup', function () {
							endClosure();
							self.$store.commit('popPopup');
						});
					}

					// Both
					if (F('deliver').value && F('pickup').value) {
						self.balanceClick('deliver', function () {
							self.balanceClick('pickup', function () {
								endClosure();
								self.$store.commit('popPopup');
			self				});

							self.$store.commit('popPopup');
						});
					}

					// None
					if (!F('deliver').value && !F('pickup').value) {
						endClosure();
					}
				}

				async function registerClaim() {
					// Claim?
					if (F('claim').value) {
						// Get remarks
						var form2 = [
							{
								label: 'Skriv her...',
								value: '',
								name: 'remarks',
								type: 'text'
							}
						];

						self.$store.commit('pushPopup', {
							component: FormPopupView,
							props: {
								title: 'Beskriv skaden',
								form: form2,
								actions: [
									{
										label: 'Send',
										callback() {
											if (form2[0].value == '') {
												alert('Du har ikke skrevet noget');
												return;
											}

											self.axios.post(`/claims/${self.task.id}/invite/`, {
												remarks: form2[0].value
											});

											registerBalance();
										}
									},
									{
										label: 'Annuller',
										callback() {
											self.$store.commit('popPopup');
										}
									}
								]
							}
						});
					} else {
						registerBalance();
					}
				}

				self.$store.commit('pushPopup', {
					component: FormPopupView,
					props: {
						title: 'Afslut opgave',
						form: form,
						actions: [
							{
								label: 'Send',
								callback() {
									registerClaim();
								}
							},
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});


				// Is task open?
				this.testClosed();
			},
			open(file) {
				const self = this;

				this.axios
					.get('/storage/urls/' + file + '/')
					.then(function (r) {
						const url = r.data.replace('storage.moovr.dk', 'mobile.moovr.dk/files');

						//window.open(r.data.replace('storage.moovr.dk', 'mobile.moovr.dk/files'));
						window.location.href = r.data;

						//self.$store.commit("openFileOverlay", r.data);
					});
			},
			openImage(file) {
				const self = this;

				this.axios
					.get('/storage/urls/' + file + '/')
					.then(function (r) {
						console.log(r.data);

						self.$store.commit('image', r.data);
					});
			},
			editComment(c) {
				if (c.employee_id != this.$store.getters.user.id) {
					console.error('Not your comment');
					return;
				}

				console.log(c);

				const form = [
					{
						label: 'Skriv her...',
						value: c.message,
						name: 'comment',
						type: 'text'
					}
				];

				const self = this;

				self.$store.commit('pushPopup', {
					component: FormPopupView,
					props: {
						title: 'Ret bemærkning',
						form: form,
						actions: [
							{
								label: 'Gem',
								async callback() {
									if (form[0].value == '') {
										alert('Du har ikke skrevet noget');
										return;
									}

									await self.axios.put(`/tasks/comments/${c.id}/`, {
										message: form[0].value
									});

									self.$store.commit('clearPopup');
									self.update();
								}
							},
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			},
			refClick() {
				console.log('ref click');

				if (!this.task) return;
				var self = this;
				var options = [];

				var test = true;

				var form = [
					{
						label: 'Skriv her...',
						value: '',
						name: 'reference',
						type: 'text'
					}
				];

				self.$store.commit('pushPopup', {
					component: FormPopupView,
					props: {
						title: 'Kundereference',
						form: form,
						actions: [
							{
								label: 'Send',
								async callback() {
									if (form[0].value == '') {
										alert('Du har ikke skrevet noget');
										return;
									}

									await self.axios.put(`/tasks/${self.task.id}/reference/`, {
										reference: form[0].value
									});

									self.$store.commit('clearPopup');
									self.update();
								}
							},
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			},
			contactClick() {
				var self = this;
				var options = [];

				var test = true;

				if (self.task && self.task.phone) {
					options.push({
						label: 'Telefon',
						value: self.task.phone,
						callback: function () {
							window.location = 'tel:' + self.task.phone;
							self.$store.commit('popPopup');
						}
					});
				}

				if (self.task && self.task.email) {
					options.push({
						label: 'E-mail',
						value: self.task.email,
						callback: function () {
							window.location = 'mailto:' + self.task.email;
							self.$store.commit('popPopup');
						}
					});
				}

				this.$store.commit('pushPopup', {
					component: SelectPopupView,
					props: {
						title: self.task ? self.task.name : '',
						options: options,
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			},

			commentClick() {
				if (!this.task) return;
				var self = this;
				var options = [];

				var test = true;

				for (var i = 0; i < this.commentTypes.length; ++i) {
					var ct = this.commentTypes[i];

					options.push({
						label: ct.label,
						callback: function () {
							var lbl = ct.label;
							var type_id = ct.id;

							return function () {
								console.log('callback');
								//window.location = 'tel:' + self.task.phone;
								//self.$store.commit('popPopup');

								var form = [
									{
										label: 'Skriv her...',
										value: '',
										name: 'comment',
										type: 'text'
									}
								];

								self.$store.commit('pushPopup', {
									component: FormPopupView,
									props: {
										title: lbl,
										form: form,
										actions: [
											{
												label: 'Send',
												callback() {
													if (form[0].value == '') {
														alert('Du har ikke skrevet noget');
														return;
													}

													self.axios.post(`/tasks/${self.task.id}/comments/`, {
														message: form[0].value,
														type_id: type_id
													});

													self.$store.commit('clearPopup');
												}
											},
											{
												label: 'Annuller',
												callback() {
													self.$store.commit('popPopup');
												}
											}
										]
									}
								});
							}
						}()
					});
				}

				this.$store.commit('pushPopup', {
					component: SelectPopupView,
					props: {
						title: 'Bemærkning',
						options: options,
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			},

			checkInClick() {
				var self = this;

				self.checkInBtn = false;

				self.axios.post('/me/stamps/', {
					lat: 0,
					lng: 0,
					type: 'in',
					task_id: self.task.id
				}).then(function (r) {
					self.axios.get('/me/stamps/active/').then(function (r) {
						console.log(r.data);
						self.$store.commit('stamps', r.data);
					});
				});

				/*
				function success(position) {
					const lat  = position.coords.latitude;
					const lng = position.coords.longitude;

					self.checkInBtn = false;

					self.axios.post('/me/stamps/', {
						lat: lat,
						lng: lng,
						type: 'in',
						task_id: self.task.id
					}).then(function (r) {
						self.axios.get('/me/stamps/active/').then(function (r) {
							console.log(r.data);
							self.$store.commit('stamps', r.data);
						});
					});
				}

				function error() {
					//self.gps = 'Unable to retrieve your location';
					window.location = 'alert:Kunne ikke checke ind, mangler lokation.';
					alert('Kunne ikke checke ind, mangler lokation.');
				}

				if (!navigator.geolocation) {
					//self.gps = 'Geolocation is not supported by your browser';
				} else {
					//self.gps = 'Locating…';
					navigator.geolocation.getCurrentPosition(success, error);
				}
					*/
			},

			checkOutClick() {
				var self = this;

				self.axios.post('/me/stamps/', {
					lat: lat,
					lng: lng,
					type: 'out',
					task_id: self.task.id
				}).then(function (r) {
					self.axios.get('/me/stamps/active/').then(function (r) {
						console.log(r.data);
						self.$store.commit('stamps', r.data);
					});
				});

				/*
				function success(position) {
					const lat  = position.coords.latitude;
					const lng = position.coords.longitude;

					self.axios.post('/me/stamps/', {
						lat: lat,
						lng: lng,
						type: 'out',
						task_id: self.task.id
					}).then(function (r) {
						self.axios.get('/me/stamps/active/').then(function (r) {
							console.log(r.data);
							self.$store.commit('stamps', r.data);
						});
					});
				}

				function error() {
					//self.gps = 'Unable to retrieve your location';
					window.location = 'alert:Kunne ikke checke ind, mangler lokation.';
					alert('Kunne ikke checke ind, mangler lokation.');
				}

				if (!navigator.geolocation) {
					//self.gps = 'Geolocation is not supported by your browser';
				} else {
					//self.gps = 'Locating…';
					navigator.geolocation.getCurrentPosition(success, error);
				}
					*/
			},

			balanceClick(type, callback) {
				if (!this.task) return;

				var preset = this.task.details.packaging;

				console.log('task', this.task);
				console.log('preset', preset);

				var self = this;

				if (!this.task.contact_id) {
					window.location = 'alert:Der er ikke tilknyttet en kunde til denne opgave.';
					alert('Der er ikke tilknyttet en kunde til denne opgave.');
					return;
				}

				var form = [];

				for (var i = 0; i < this.pack.length; ++i) {
					form.push({
						label: this.pack[i].label,
						value: preset.hasOwnProperty(this.pack[i].id) ? preset[this.pack[i].id] : 0,
						name: this.pack[i].id,
						type: 'number'
					});
				}

				self.$store.commit('pushPopup', {
					component: FormPopupView,
					props: {
						title: type == 'deliver' ? 'Leveret' : 'Afhentet',
						form: form,
						actions: [
							{
								label: 'Send',
								callback(e, data) {
									// Block multiple clicks
									console.log('send balance', self.sendingBalance);

									if (self.sendingBalance) {
										console.log('blocked!!');
										return;
									}

									self.sendingBalance = true;


									var prods = form.reduce(function (acc, p) { if (p.value <= 0) return acc; acc[p.name] = p.value; return acc; }, {});
									console.log('prods', prods);

									if (Object.keys(prods).length == 0) {
										alert('Du har ikke sat antal på emballagen.');
										return;
									}
									

									self.axios.post('/contact/' + self.task.contact_id + '/packaging/action/' + type + '/', {
										products: prods
									}).then(function (r) {
										//console.log(r.data);
										//self.$store.commit('stamps', r.data);

										self.sendingBalance = false;

										if (type == 'deliver') {
											// Capture the customer's signed receipt right after
											// the delivery is registered.
											var items = form.reduce(function (acc, p) { if (p.value <= 0) return acc; acc.push({ label: p.label, qty: Number(p.value) }); return acc; }, []);
											self.signDeliveryStep(items, callback);
										} else {
											callback();
											self.$store.commit('clearPopup');
										}
									}).catch(function (e) {
										console.log(e);

										window.location = 'alert:Kunne ikke oprette registreringen, sikker på at kunden har antallet til rådighed?';
										alert('Kunne ikke oprette registreringen, sikker på at kunden har antallet til rådighed?');
										self.sendingBalance = false;
									});
								}
							},
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			},

			signDeliveryStep(items, callback) {
				var self = this;

				var model = {
					signature: null,
					opt_in: true,
					email: (this.task && this.task.email) ? this.task.email : ''
				};

				self.$store.commit('pushPopup', {
					component: SignaturePopupView,
					props: {
						title: 'Kvittering',
						items: items,
						liability: self.deliveryLiability,
						model: model,
						actions: [
							{
								label: 'Send',
								callback() {
									if (!model.signature) {
										alert('Kunden skal underskrive.');
										return;
									}

									if (self.signingDelivery) return;
									self.signingDelivery = true;

									self.axios.post('/contact/' + self.task.contact_id + '/packaging/sign/', {
										items: items,
										signature: model.signature,
										liability_text: self.deliveryLiability,
										email_opt_in: model.opt_in,
										email_recipient: model.opt_in ? model.email : null
									}).then(function () {
										self.signingDelivery = false;
										callback();
										self.$store.commit('clearPopup');
									}).catch(function (e) {
										console.log(e);
										self.signingDelivery = false;
										window.location = 'alert:Kunne ikke gemme underskriften.';
										alert('Kunne ikke gemme underskriften.');
									});
								}
							},
							{
								label: 'Annuller',
								callback() {
									// Delivery is already registered; continue the
									// closing flow without a signature.
									callback();
									self.$store.commit('clearPopup');
								}
							}
						]
					}
				});
			},

			navigationClick(st) {
				console.log('nav');
				var uri = 'http://maps.apple.com/?q=' + encodeURI(st.address + ',' + st.zip + ',' + st.city + ',' + st.country);
				console.log('nav', uri);
				window.location = uri;
			},




			create() {
				var self = this;

				this.$store.commit('pushModal', {
					component: UserFragment,
					props: {},
					events: {
						created() {
							self.update();
						}
					}
				});
			},
			itemClick(item) {
				var self = this;

				console.log(item);

				this.$store.commit('pushModal', {
					component: UserFragment,
					props: {
						id: item.id
					},
					events: {
						updated() {
							self.update();
						}
					}
				});
			},
			itemDelete(item) {
				var self = this;

				this.axios.delete('/portal/users/' + item.id + '/').then(function () {
					self.update();
				});
			},
			update() {
				var self = this;

				console.log(this.$route);

				this.axios.get('/planning/tasks/' + this.$route.params.id + '/').then(function (r) {
					self.task = r.data;

					self.axios.get('/sales/orders/' + r.data.order_id + '/').then(function (r) {
						self.order = r.data;
					});
				});
			},
			dateClick() {
				var self = this;

				this.$store.commit('pushPopup', {
					component: DatePopupView,
					props: {
						title: 'Vælg dato',
						date: this.date,
						callback(e) {
							console.log(e);
							self.date = e;
							self.$store.commit('popPopup');
						},
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			},
			async updateCommentTypes() {
				console.log('update comment types');
				this.commentTypes = (await this.axios.get('/tasks/comments/types/')).data._items;
			}
		},
		mounted() {
			this.update();

			var self = this;

			this.axios.get('/us/settings/').then(function (r) {
				self.settings = r.data;

				console.log(self.settings);
			});

			this.axios.get('/tasks/types/').then(function (r) {
				self.taskTypes = r.data._items;
			});

			this.axios.get('/tasks/instructions/').then(function (r) {
				self.instructions = r.data._items;
			});

			this.axios.get('/products/packaging/').then(function (r) {
				self.pack = r.data._items;
			});

			this.axios.get('/products/deliveries/').then(function (r) {
				self.deliveries = r.data._items;
			});

			this.$bus.$on('update', function () {
				self.update();
			});
			
			console.log('async call!');
			this.updateCommentTypes();

			// Test perms
			console.log('QUERY', JSON.stringify(this.$route.query));

			//if (this.$route.query._cache || true) {
				/*setTimeout(() => {
					window.location = 'perms:' + this.$store.getters.auth;
				}, 2000);*/
			//}
		}
	}
</script>

<style lang="scss" scoped>
	.calendar-page {
		& .camera {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			background-color: yellow;
		}

		& > .content {
			display: grid;
			grid-template-rows: 60px 1fr;

			& > .header {
				border-bottom: 4px solid #f0f0f0;
				font-size: 14px;
				font-weight: bold;
				padding-left: 20px;
				line-height: 60px;

				& > .tab {
					display: inline-block;
					margin-right: 20px;
					height: 56px;
					font-size: 12px;

					&.active {
						border-bottom: 4px solid red;
					}
				}

				& > .icon {
					width: 24px;
					height: 24px;
				}
			}

			& > .body, & > .body.route > .body {
				overflow-y: auto;
				background: rgb(241, 241, 241);

				&.route {
					display: grid;
					grid-template-rows: 1fr 64px;

					& > .stops {
						border-top: 4px solid #f0f0f0;
						background-color: white;
						padding: 20px 0 20px 0;

						& > .stops-center {
							display: grid;
							grid-template-columns: 1fr 20px 1fr 20px 1fr;
							height: 100%;

							& > .stop {
								position: relative;
								background-color: #f7223f;
								border-radius: 50%;

								& > .halo {
									position: absolute;
									left: -6px;
									top: -6px;
									width: 32px;
									height: 32px;
									border: 4px solid #f7223f;
									border-radius: 50%;
									display: none;
								}
								
								&.active {
									& > .halo {
										display: block;
									}
								}
							}

							& > .center {
								position: relative;

								& > .line {
									position: absolute;
									top: 50%;
									margin-top: -2px;
									height: 4px;
									background-color: #f7223f;
									left: 2px;
									right: 2px;
								}
							}
						}
					}
				}

				& > .photos {
					padding: 10px;
					display: grid;
					grid-template-columns: 1fr 1fr 1fr;
					row-gap: 10px;
					column-gap: 10px;

					& > .thumb {
						background-size: cover;
						border-radius: 5px;

						&.button {
							background-color: #f7223f;
							background-size: 50%;
							background-position: center center;
							background-repeat: no-repeat;

							
						}

						& > .square {
							width: 0;
							padding-top: 100%;
						}	
					}
				}

				& > .table {
					display: grid;
					row-gap: 10px;
					padding: 10px;
					overflow-y: auto;

					& > .title {
						padding-left: 10px;
						margin-top: 10px;
					}

					& > div:first-child {
						margin-top: 0;
					}

					& > .button {
						background-color:#f7223f;
						border-radius: 5px;
						color: white;
						text-align: center;
						font-weight: bold;
						line-height: 48px;
						font-size: 16px;

						&.done {
							background-color: #00c017;
						}
					}

					& > .item {
						background-color: white;
						position: relative;
						border-radius: 5px;
						overflow: hidden;
						min-height: 0;

						-webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);
						-moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);
						box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);

						&.customer {
							display: grid;
							row-gap: 1px;
							background-color: #ececec;

							& > div {
								padding: 10px;
								background-color: white;

								&.name {
									font-weight: bold;
								}
							}
						}

						&.instruction {
							display: grid;
							row-gap: 1px;
							background-color: #ececec;

							& > div {
								padding: 10px;
								background-color: white;

								&.title {
									font-weight: bold;
								}
							}
						}

						&.packaging {
							display: grid;
							row-gap: 1px;
							background-color: #ececec;

							& > div {
								background-color: white;

								&.title {
									padding: 10px;
									font-weight: bold;
								}

								&.item {
									display: grid;
									grid-template-columns: 2fr 1fr;

									& > div {
										padding: 10px;

										&.value {
											text-align: right;
											font-weight: bold;
										}
									}
								}
							}
						}

						&.arrival {
							display: grid;
							grid-template-columns: 1fr 1fr;

							& > div {
								padding: 10px;

								&.time {
									text-align: right;
								}
							}
						}

						&.remarks {
							padding: 10px;
						}

						&.file {
							display: grid;
							grid-template-columns: 1fr 1fr;

							& > div {
								padding: 10px;

								&.type {
									text-align: right;
								}
							}
						}
					}
				}
			}
		}
	}
</style>